/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConditionCreateRequest
 */
export interface ConditionCreateRequest {
    /**
     * The type of this `Condition` (URL, GEO, or CHAT)
     * @type {string}
     * @memberof ConditionCreateRequest
     */
    conditionType: ConditionCreateRequestConditionTypeEnum;
    /**
     * Whether this condition includes or excludes the matched URLs
     * @type {string}
     * @memberof ConditionCreateRequest
     */
    filterType: ConditionCreateRequestFilterTypeEnum;
    /**
     * The matching strategy used to evaluate the condition value
     * @type {string}
     * @memberof ConditionCreateRequest
     */
    matchType: ConditionCreateRequestMatchTypeEnum;
    /**
     * The value to match against (e.g. URL path, country code)
     * @type {string}
     * @memberof ConditionCreateRequest
     */
    matchValue: string;
}


/**
 * @export
 */
export const ConditionCreateRequestConditionTypeEnum = {
    Url: 'URL',
    Geo: 'GEO',
    Chat: 'CHAT'
} as const;
export type ConditionCreateRequestConditionTypeEnum = typeof ConditionCreateRequestConditionTypeEnum[keyof typeof ConditionCreateRequestConditionTypeEnum];

/**
 * @export
 */
export const ConditionCreateRequestFilterTypeEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;
export type ConditionCreateRequestFilterTypeEnum = typeof ConditionCreateRequestFilterTypeEnum[keyof typeof ConditionCreateRequestFilterTypeEnum];

/**
 * @export
 */
export const ConditionCreateRequestMatchTypeEnum = {
    Simple: 'SIMPLE',
    Exact: 'EXACT',
    Regex: 'REGEX',
    Substring: 'SUBSTRING',
    CountryCode: 'COUNTRY_CODE',
    AgentsAvailable: 'AGENTS_AVAILABLE'
} as const;
export type ConditionCreateRequestMatchTypeEnum = typeof ConditionCreateRequestMatchTypeEnum[keyof typeof ConditionCreateRequestMatchTypeEnum];


/**
 * Check if a given object implements the ConditionCreateRequest interface.
 */
export function instanceOfConditionCreateRequest(value: object): value is ConditionCreateRequest {
    if (!('conditionType' in value) || value['conditionType'] === undefined) return false;
    if (!('filterType' in value) || value['filterType'] === undefined) return false;
    if (!('matchType' in value) || value['matchType'] === undefined) return false;
    if (!('matchValue' in value) || value['matchValue'] === undefined) return false;
    return true;
}

export function ConditionCreateRequestFromJSON(json: any): ConditionCreateRequest {
    return ConditionCreateRequestFromJSONTyped(json, false);
}

export function ConditionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'conditionType': json['conditionType'],
        'filterType': json['filterType'],
        'matchType': json['matchType'],
        'matchValue': json['matchValue'],
    };
}

export function ConditionCreateRequestToJSON(json: any): ConditionCreateRequest {
    return ConditionCreateRequestToJSONTyped(json, false);
}

export function ConditionCreateRequestToJSONTyped(value?: ConditionCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditionType': value['conditionType'],
        'filterType': value['filterType'],
        'matchType': value['matchType'],
        'matchValue': value['matchValue'],
    };
}

